import { POST_PATIENT_SUCCESS } from "../actions/patientAction"


const createPatientReducer = (state = [], { type,  data=[] }) => {
  switch (type) {
    case POST_PATIENT_SUCCESS:
      return data
    default:
      return state
  }
}

export default createPatientReducer